import React, { useState } from 'react';
import { Download, Search, Eye, Edit, Ban, UserPlus, Filter } from 'lucide-react';
import { Button } from '../components/ui/Button';
import { Input } from '../components/ui/Input';
import { Card, CardContent } from '../components/ui/Card';
import { Badge } from '../components/ui/Badge';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '../components/ui/Table';
import { Avatar, AvatarFallback } from '../components/ui/Avatar';
import { useNavigate } from 'react-router-dom';
export function AdminMembers() {
  const navigate = useNavigate();
  const [searchQuery, setSearchQuery] = useState('');
  const [statusFilter, setStatusFilter] = useState('all');
  const [typeFilter, setTypeFilter] = useState('all');
  const members = [{
    id: 1,
    name: 'John Doe',
    email: 'john@example.com',
    type: 'Pelajar',
    status: 'Aktif',
    joined: '1 Jan 2023',
    chapter: 'Jakarta Tech'
  }, {
    id: 2,
    name: 'Jane Smith',
    email: 'jane@example.com',
    type: 'Umum',
    status: 'Aktif',
    joined: '15 Feb 2023',
    chapter: 'Bandung Dev'
  }, {
    id: 3,
    name: 'Robert Johnson',
    email: 'robert@example.com',
    type: 'Umum',
    status: 'Tidak Aktif',
    joined: '10 Mar 2023',
    chapter: 'Surabaya Tech'
  }, {
    id: 4,
    name: 'PT Tech Indonesia',
    email: 'contact@techindonesia.com',
    type: 'Organisasi',
    status: 'Aktif',
    joined: '22 Mar 2023',
    chapter: '-'
  }, {
    id: 5,
    name: 'Michael Brown',
    email: 'michael@example.com',
    type: 'Pelajar',
    status: 'Ditangguhkan',
    joined: '5 Apr 2023',
    chapter: 'Jakarta Tech'
  }];
  const filteredMembers = members.filter(member => {
    const matchesSearch = member.name.toLowerCase().includes(searchQuery.toLowerCase()) || member.email.toLowerCase().includes(searchQuery.toLowerCase());
    const matchesStatus = statusFilter === 'all' || member.status === statusFilter;
    const matchesType = typeFilter === 'all' || member.type === typeFilter;
    return matchesSearch && matchesStatus && matchesType;
  });
  const getStatusBadge = (status: string) => {
    switch (status) {
      case 'Aktif':
        return <Badge variant="success" data-id="element-934">Aktif</Badge>;
      case 'Tidak Aktif':
        return <Badge variant="default" data-id="element-935">Tidak Aktif</Badge>;
      case 'Ditangguhkan':
        return <Badge variant="error" data-id="element-936">Ditangguhkan</Badge>;
      default:
        return <Badge data-id="element-937">{status}</Badge>;
    }
  };
  const handleView = (id: number) => {
    navigate(`/admin/members/${id}`);
  };
  const handleEdit = (id: number) => {
    navigate(`/admin/members/${id}/edit`);
  };
  const handleSuspend = (id: number) => {
    if (confirm('Apakah Anda yakin ingin menangguhkan anggota ini?')) {
      alert(`Anggota #${id} telah ditangguhkan`);
    }
  };
  const handleExport = () => {
    alert('Mengekspor data anggota...');
  };
  return <div className="min-h-screen bg-white py-8 px-4 sm:px-6 lg:px-8" data-id="element-938">
      <div className="max-w-7xl mx-auto" data-id="element-939">
        <div className="flex flex-col md:flex-row md:items-center justify-between mb-8 gap-4" data-id="element-940">
          <div data-id="element-941">
            <h1 className="text-3xl font-semibold text-neutral-900 mb-2" data-id="element-942">
              Kelola Anggota
            </h1>
            <p className="text-neutral-600" data-id="element-943">2.450 anggota terdaftar</p>
          </div>
          <div className="flex gap-3" data-id="element-944">
            <Button variant="secondary" onClick={handleExport} data-id="element-945">
              <Download className="w-4 h-4 mr-2" data-id="element-946" />
              Export Data
            </Button>
            <Button onClick={() => navigate('/admin/members/create')} data-id="element-947">
              <UserPlus className="w-4 h-4 mr-2" data-id="element-948" />
              Tambah Anggota
            </Button>
          </div>
        </div>

        <Card className="mb-8" data-id="element-949">
          <CardContent className="p-6" data-id="element-950">
            <div className="flex flex-col md:flex-row gap-4" data-id="element-951">
              <div className="flex-1 relative" data-id="element-952">
                <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-neutral-400" data-id="element-953" />
                <Input className="pl-10" placeholder="Cari nama atau email..." value={searchQuery} onChange={e => setSearchQuery(e.target.value)} data-id="element-954" />
              </div>
              <div className="w-full md:w-48" data-id="element-955">
                <select className="flex h-9 w-full rounded-md border border-neutral-300 bg-white px-3 py-2 text-sm text-neutral-900 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-atios-primary" value={statusFilter} onChange={e => setStatusFilter(e.target.value)} data-id="element-956">
                  <option value="all" data-id="element-957">Semua Status</option>
                  <option value="Aktif" data-id="element-958">Aktif</option>
                  <option value="Tidak Aktif" data-id="element-959">Tidak Aktif</option>
                  <option value="Ditangguhkan" data-id="element-960">Ditangguhkan</option>
                </select>
              </div>
              <div className="w-full md:w-48" data-id="element-961">
                <select className="flex h-9 w-full rounded-md border border-neutral-300 bg-white px-3 py-2 text-sm text-neutral-900 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-atios-primary" value={typeFilter} onChange={e => setTypeFilter(e.target.value)} data-id="element-962">
                  <option value="all" data-id="element-963">Semua Tipe</option>
                  <option value="Pelajar" data-id="element-964">Pelajar</option>
                  <option value="Umum" data-id="element-965">Umum</option>
                  <option value="Organisasi" data-id="element-966">Organisasi</option>
                  <option value="Badan Usaha" data-id="element-967">Badan Usaha</option>
                </select>
              </div>
            </div>
          </CardContent>
        </Card>

        <Card data-id="element-968">
          <CardContent className="p-0" data-id="element-969">
            <Table data-id="element-970">
              <TableHeader data-id="element-971">
                <TableRow data-id="element-972">
                  <TableHead className="w-[50px]" data-id="element-973"></TableHead>
                  <TableHead data-id="element-974">Nama</TableHead>
                  <TableHead data-id="element-975">Email</TableHead>
                  <TableHead data-id="element-976">Tipe</TableHead>
                  <TableHead data-id="element-977">Status</TableHead>
                  <TableHead data-id="element-978">Chapter</TableHead>
                  <TableHead data-id="element-979">Bergabung</TableHead>
                  <TableHead className="text-right" data-id="element-980">Aksi</TableHead>
                </TableRow>
              </TableHeader>
              <TableBody data-id="element-981">
                {filteredMembers.map(member => <TableRow key={member.id} data-id="element-982">
                    <TableCell data-id="element-983">
                      <Avatar size="sm" data-id="element-984">
                        <AvatarFallback data-id="element-985">
                          {member.name.substring(0, 2).toUpperCase()}
                        </AvatarFallback>
                      </Avatar>
                    </TableCell>
                    <TableCell className="font-medium text-neutral-900" data-id="element-986">
                      {member.name}
                    </TableCell>
                    <TableCell className="text-neutral-600" data-id="element-987">
                      {member.email}
                    </TableCell>
                    <TableCell data-id="element-988">
                      <Badge variant="default" data-id="element-989">{member.type}</Badge>
                    </TableCell>
                    <TableCell data-id="element-990">{getStatusBadge(member.status)}</TableCell>
                    <TableCell className="text-neutral-600" data-id="element-991">
                      {member.chapter}
                    </TableCell>
                    <TableCell className="text-neutral-600" data-id="element-992">
                      {member.joined}
                    </TableCell>
                    <TableCell className="text-right" data-id="element-993">
                      <div className="flex justify-end gap-2" data-id="element-994">
                        <Button size="sm" variant="ghost" onClick={() => handleView(member.id)} data-id="element-995">
                          <Eye className="w-4 h-4" data-id="element-996" />
                        </Button>
                        <Button size="sm" variant="ghost" onClick={() => handleEdit(member.id)} data-id="element-997">
                          <Edit className="w-4 h-4" data-id="element-998" />
                        </Button>
                        <Button size="sm" variant="ghost" className="text-error hover:text-error" onClick={() => handleSuspend(member.id)} data-id="element-999">
                          <Ban className="w-4 h-4" data-id="element-1000" />
                        </Button>
                      </div>
                    </TableCell>
                  </TableRow>)}
              </TableBody>
            </Table>
          </CardContent>
        </Card>

        <div className="flex items-center justify-between mt-6" data-id="element-1001">
          <p className="text-sm text-neutral-600" data-id="element-1002">
            Menampilkan 1-10 dari 2.450 anggota
          </p>
          <div className="flex gap-2" data-id="element-1003">
            <Button variant="secondary" disabled data-id="element-1004">
              Sebelumnya
            </Button>
            <Button variant="secondary" data-id="element-1005">Selanjutnya</Button>
          </div>
        </div>
      </div>
    </div>;
}